/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from "react";
import styles from "styles/pages/RangeInformation.module.scss";
import Wrapper from "layout/Wrapper/Wrapper";
import asset from "json/assets";
import { Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomInput from "ui/CustomInput/CustomInput";
import CustomButton from "ui/CustomButton/CustomButton";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useDispatch } from "react-redux";
import { course_details, course_list } from "redux/CourseSlice";
import {
  convertAPIResposeToUsableShape,
  convertSingleLatLngStringtoFloatArray,
  decryptSecretKey,
  getModalProperties,
  isNumeric,
} from "services/utils";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import validationText from "../../json/message/Validation";
import {
  addWithDisplayedCourses,
  country_list,
  displayCourseList,
  rangeInfo_details,
  rangeInfo_update,
  removeCoursesOfRangeDetails,
  state_list,
} from "redux/RangeInfoSlice";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import useNotiStack from "hooks/useNotistack";
import BackdropLoader from "ui/BackdropLoader/BackdropLoader";
import ModalWrapper from "layout/ModalWrapper/ModalWrapper";
import NoificationModal from "pages/ModalPage/NoificationModal";
import CustomInputNoLabel from "ui/CustomInputNoLabel/CustomInputNoLabel";
import RangeInfoSkeleton from "ui/Skeletons/RangeInfoSkeleton";
import SideBarActions from "layout/SideBarActions/SideBarActions";
import {
  useAssociatedCourseData,
  useAssociatedCoursesOfRangeDetails,
  useRangeInfoDetails,
} from "hooks/RangeDetails";
import { useProfileData } from "hooks/ProfileDetails";
import {
  driving_range_gps_details,
  driving_range_gps_update,
} from "redux/MapSlice";
import { classification, statusForEdit } from "json/constants";
import wrapperStyles from "styles/pages/Map1.module.scss";


const EditRangeInformation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const secret_Key = decryptSecretKey();
  const [searchParams] = useSearchParams();
  const id_drivingRangeFromQuery = searchParams.get("range"); // for queryString
  const id_adminuser = localStorage.getItem("id_adminuser");
  const profileDetails = JSON.parse(localStorage.getItem("profile_data"));
  const modalProperties = getModalProperties();
  const { toastSuccess, toastError } = useNotiStack();

  const profileData = useProfileData();
  const courseData = useAssociatedCourseData();
  const rangeInfoDetails = useRangeInfoDetails();
  const coursesOfRangeDetails = useAssociatedCoursesOfRangeDetails();

  const [statusopenBtn, setStatusopenBtn] = useState(false);
  const [courses, setCourses] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingCountryList, setLoadingCountryList] = useState(false);
  const [loadingStateList, setLoadingStateList] = useState(false);
  // const [loadingforFetch, setLoadingforFetch] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [loadingCourses, setLoadingCourses] = useState(false);
  const [error, setError] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [countryData, setCountryData] = useState([]);
  const [stateForDrivingRange, setStateForDrivingRange] = useState();
  const [idCountryValue, setIdCountryValue] = useState();
  const [drivingRangeDetails, setDrivingRangeDetails] = useState();
  const [user, setUser] = useState(null);
  const [latLonPoints, setLatLonPoints] = useState();
  const [rangeGpsDetails, setRangeGpsDetails] = useState();
  const [sideBarExpanded, setSideBarExpanded] = useState();

  // by id no of course
  const courseDetails = courseData?.course_details_data;
  // by name of course
  const activeCourseList = courseData?.course_list_data?.courseList;

  const handleRange = (e) => {
    setCourses(e.target.value);
  };

  const schema = yup.object().shape({
    rangeName: yup.string().trim().required(),
    address1: yup.string().trim().required(),
    city: yup.string().trim().required(),
    country: yup.string().required(),
    latitude: yup.string().required(),
    longitude: yup.string().required(),
  });

  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors, dirtyFields },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      state: undefined,
    },
  });

  const handleClickOpen = () => {
    if (
      dirtyFields?.rangeName ||
      dirtyFields?.classification ||
      dirtyFields?.address1 ||
      dirtyFields?.address2 ||
      dirtyFields?.city ||
      dirtyFields?.state ||
      dirtyFields?.otherState ||
      dirtyFields?.zip ||
      dirtyFields?.country ||
      dirtyFields?.phone ||
      dirtyFields?.website
    ) {
      setOpen(true); // w/o saving by cancle modal open
    } else {
      navigate("/drivingrange");
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  const redirectToPage = () => {
    setOpen(false);
  };

  const navigateToDrivingRange = () => {
    navigate("/drivingrange");
  };

  const handleRedirect = (data) => {
    setLoading(true);
    dispatch(
      course_details({
        body: {
          id_courseInt: parseInt(courses),
          stateFormat: 4,
          countryFormat: 4,
          detailLevel: 2,
        },
        user: {
          secretKey: secret_Key,
          userName: profileData?.profile_information_data?.username,
        },
      })
    )?.then((res) => {
      if (res?.payload?.data?.Status === 1) {
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  const handleRedirectCourse = (data) => {
    if (courses && courses?.length >= 2) {
      setLoading(true);
    }
    dispatch(
      course_list({
        body: {
          //  id_adminuser: id_adminuser,
          courseName: courses,
          stateFormat: 4,
          teeTimesAvailable: 1,
          page: 1,
          resultsPerPage: 100,
        },
        user: {
          secretKey: secret_Key,
          userName: profileData?.profile_information_data?.username,
        },
      })
    )?.then((res) => {
      if (res?.payload?.data?.Status === 1) {
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  let isNumericName = isNumeric(courses);
  useEffect(() => {
    if (courses && courses?.length > 0) {
      const delayDebounceFn = setTimeout(() => {
        if (isNumericName) {
          setError(false);
          handleRedirect();
        } else {
          if (courses && courses?.length < 2) {
            setError(true);
          } else {
            setError(false);
          }
          handleRedirectCourse();
        }
      }, 400);
      return () => clearTimeout(delayDebounceFn);
    } else {
      setCourses("");
      setError(false);
    }
  }, [courses]);

  let courseIdList = [];
  coursesOfRangeDetails &&
    coursesOfRangeDetails?.map((e) => {
      courseIdList.push(e?.id_courseInt);
    });

  const addSelectCourseList = (e, selectedCourse) => {
    dispatch(addWithDisplayedCourses(selectedCourse));
  };
  const addSelectCourseDetails = (e) => {
    dispatch(addWithDisplayedCourses(courseDetails));
  };

  useEffect(() => {
    setLoadingCountryList(true);
    setLoadingCourses(true);
    dispatch(
      country_list({
        body: {
          // id_adminuser: id_adminuser,
          // id_continent: "NA",
        },
        user: {
          secretKey: secret_Key,
          userName: profileDetails?.username,
        },
      })
    )?.then((res) => {
      if (res?.payload?.data?.Status === 1) {
        setCountryData(res?.payload?.data?.countryList);
        setLoadingCountryList(false);
      } else {
        toastError("Something went wrong");
      }
    });

    // rangeinfo details
    dispatch(
      rangeInfo_details({
        body: {
          id_drivingRange: id_drivingRangeFromQuery,
          id_drivingRangeInt: parseInt(params?.id),
          countryFormat: 4,
          stateFormat: 4,
        },
        user: {
          secretKey: secret_Key,
          userName: profileDetails?.username,
        },
      })
    )?.then((res) => {
      if (res?.payload?.data?.Status === 1) {
        setLoadingCourses(false);
        setDrivingRangeDetails(res?.payload?.data);
        dispatch(displayCourseList(res?.payload?.data?.courseArray));
        dispatch(
          state_list({
            body: {
              id_adminuser: id_adminuser,
              id_country: res?.payload?.data && res?.payload?.data?.id_country,
            },
            user: {
              secretKey: secret_Key,
              userName: profileDetails?.username,
            },
          })
        )?.then((res) => {
          if (res?.payload?.data?.Status === 1) {
            setStateForDrivingRange(res?.payload?.data?.stateList);
          }
        });
      } else {
        toastError("Something went wrong");
      }
    });

    // range gps details
    dispatch(
      driving_range_gps_details({
        body: {
          id_drivingRange: id_drivingRangeFromQuery,
        },
        user: {
          secretKey: secret_Key,
          userName: profileDetails?.username,
        },
      })
    )?.then((res) => {
      if (res?.payload?.data?.Status === 1) {
        let point = convertSingleLatLngStringtoFloatArray(
          res?.payload?.data?.shapes[0]?.facilityMarker[0]?.points[0]
        );
        setLatLonPoints(point);

        let convertedShapeData = convertAPIResposeToUsableShape(
          res?.payload?.data?.shapes
        );
        let reduxObject = {
          info: res?.payload?.data?.info,
          shapes: convertedShapeData,
        };
        setRangeGpsDetails(reduxObject);
      }
    });
  }, []);

  const handleRemove = (item) => {
    let filtered = coursesOfRangeDetails.filter((e) => e !== item);

    let filteredCourses = filtered;
    dispatch(removeCoursesOfRangeDetails(filteredCourses));
  };

  // for prevent submitting form by press enter
  const handleKeyPress = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
    }
  };
  document.addEventListener("keypress", handleKeyPress);

  const handleSelectMenu = (e, selectedMenu) => {
    setStateForDrivingRange(undefined);
    setIdCountryValue(selectedMenu?.id_country);
    setLoadingStateList(true);
    setValue("state", undefined);
    dispatch(
      state_list({
        body: {
          id_adminuser: id_adminuser,
          id_country: selectedMenu?.id_country,
        },
        user: {
          secretKey: secret_Key,
          userName: profileDetails?.username,
        },
      })
    )?.then((res) => {
      if (res?.payload?.data?.Status === 1) {
        if (res?.payload?.data?.stateList?.length !== 0) {
          setStateForDrivingRange(res?.payload?.data?.stateList);
        }
        setLoadingStateList(false);
      } else {
        setLoadingStateList(false);
      }
    });
  };

  const onSubmit = async (data) => {
    setSubmitLoading(true);
    dispatch(
      rangeInfo_update({
        body: {
          id_drivingRange:
            rangeInfoDetails && rangeInfoDetails?.id_drivingRange,
          id_drivingRangeInt:
            rangeInfoDetails && rangeInfoDetails?.id_drivingRangeInt,
          rangeName: data?.rangeName.trim(),
          address1: data?.address1.trim(),
          city: data.city.trim(),
          id_country: parseInt(data?.country),
          class: data.classification,
          address2: data.address2 && data.address2.trim(),
          id_state: data.state,
          otherState: data.otherState && data.otherState.trim(),
          zipCode: data.zip,
          phone: data.phone && data.phone.trim(),
          website: data.website && data.website.trim(),
          active: data.status ? parseInt(data.status): 1,
          courseArray: courseIdList,
        },
        user: {
          secretKey: secret_Key,
          userName: profileDetails?.username,
        },
      })
    )?.then((res) => {
      if (res?.payload?.data?.Status === 1) {
        toastSuccess(res?.payload?.data?.ErrorMessage);
        setSubmitLoading(false);

        const latLonpoints = [`${data?.latitude},${data?.longitude}`];
        let payloadObject = {};
        if (rangeGpsDetails?.shapes && rangeGpsDetails.shapes.facilityMarker) {
          //if range has shape data
          rangeGpsDetails.shapes.facilityMarker[0].points = latLonpoints;
          payloadObject = rangeGpsDetails;
        } else {
          //if range does not have shape data

          payloadObject = {
            info: {
              id_drivingRange: id_drivingRangeFromQuery,
            },
            shapes: {
              facilityMarker: [
                {
                  label: "FM1",
                  points: latLonpoints,
                  type: "point",
                },
              ],
            },
          };
        }
        //  lat lon update
        dispatch(
          driving_range_gps_update({
            // body: rangeGpsDetails,
            body: payloadObject,
            user: {
              secretKey: secret_Key,
              userName: profileDetails?.username,
            },
          })
        );
        // // lat lon update-

        navigate("/drivingrange");
      } else {
        setSubmitLoading(false);
        toastError("Network Error");
      }
    });
  };

  // effect runs on component mount
  useEffect(() => {
    // simulate async api call
    setUser({
      rangeName: drivingRangeDetails?.rangeName,
      classification: drivingRangeDetails?.class,
      address1: drivingRangeDetails?.address1,
      address2: drivingRangeDetails?.address2,
      city: drivingRangeDetails?.city,
      state: drivingRangeDetails?.id_state,
      otherState: drivingRangeDetails?.otherState,
      zip: drivingRangeDetails?.zipCode,
      country: drivingRangeDetails?.id_country,
      phone: drivingRangeDetails?.phone,
      website: drivingRangeDetails?.url,
      status: drivingRangeDetails?.active?.toString(),
      latitude: latLonPoints && latLonPoints[0],
      longitude: latLonPoints && latLonPoints[1],
    });
  }, [drivingRangeDetails, latLonPoints]);

  // effect runs when user state is updated
  useEffect(() => {
    // reset form with user data
    reset(user);
  }, [user]);

  return (
    <div className="main_wraper">
      <Wrapper isHeader={true} headerTitle={"DRIVING RANGE"}>
        <div
            className={
              sideBarExpanded
                ? `${wrapperStyles.main_wrapper_flex}`
                : `${wrapperStyles.main_wrapper_flex} ${wrapperStyles.main_wrapper_flex_open}`
            }
          >
            <div className={wrapperStyles.main_left}>
              <div className={styles.sideBar}>
                <SideBarActions 
                  form='editRangeInfo'
                  onCancelClick={handleClickOpen}
                  toggleSideBar={() => setSideBarExpanded(prev => !prev)} />
              </div>
            </div>
          <div className={wrapperStyles.main_rgt}>
            <div className={styles.range_sec}>
              <form id='editRangeInfo' onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={0}>
                  <Grid item md={6} xs={12}>
                    <div className={styles.range_sec_box}>
                      <div className={styles.range_head}>
                        <p>Edit Range Information</p>
                      </div>
                      {loadingCountryList ? (
                        <RangeInfoSkeleton />
                      ) : (
                        <div className={`${styles.range_form} ${styles.range_form_cmn}`}>
                          <div className={styles.formSec}>
                            <Grid container spacing={0}>
                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  <Grid container spacing={2}>
                                    <Grid item xs={5} md={5}>
                                      <label>Range Name *</label>
                                    </Grid>
                                    <Grid item xs={7} md={7}>
                                      {errors.rangeName && (
                                        <p className={styles.requiredContent}>
                                          {validationText.error.rangeName}
                                        </p>
                                      )}
                                    </Grid>
                                  </Grid>
                                  <Controller
                                    control={control}
                                    name="rangeName"
                                    render={({ field: { onChange, value } }) => (
                                      <CustomInputNoLabel
                                        placeholder=""
                                        type="text"
                                        value={value}
                                        onChange={onChange}
                                        disabled={submitLoading}
                                      />
                                    )}
                                  />
                                </div>
                              </Grid>
                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  <label>CLASSIFICATION</label>
                                  <FormControl sx={{ m: 1, minWidth: 120 }}>
                                    <Controller
                                      control={control}
                                      name="classification"
                                      // {...register("classification")}
                                      render={({ field: { onChange, value } }) => (
                                        <Select
                                          defaultValue=""
                                          id="demo-simple-select"
                                          onChange={onChange}
                                          // value={value}
                                          value={value ? value : ""}
                                        >
                                          {classification?.map((e) => {
                                            return (
                                              <MenuItem
                                                key={e?.id}
                                                value={e?.value}
                                              >
                                                {e?.label}
                                              </MenuItem>
                                            );
                                          })}
                                        </Select>
                                      )}
                                    />
                                  </FormControl>
                                </div>
                              </Grid>
                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  <Grid container spacing={2}>
                                    <Grid item xs={5} md={5}>
                                      <label>ADDRESS 1*</label>
                                    </Grid>
                                    <Grid item xs={7} md={7}>
                                      {errors.address1 && (
                                        <p className={styles.requiredContent}>
                                          {validationText.error.address1}
                                        </p>
                                      )}
                                    </Grid>
                                  </Grid>
                                  <Controller
                                    control={control}
                                    name="address1"
                                    render={({ field: { onChange, value } }) => (
                                      <CustomInputNoLabel
                                        placeholder=""
                                        type="text"
                                        value={value}
                                        onChange={onChange}
                                        disabled={submitLoading}
                                      />
                                    )}
                                  />
                                </div>
                              </Grid>
                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  <Controller
                                    control={control}
                                    name="address2"
                                    render={({ field: { onChange, value } }) => (
                                      <CustomInput
                                        placeholder=""
                                        type="text"
                                        value={value}
                                        onChange={onChange}
                                        label="ADDRESS 2"
                                        disabled={submitLoading}
                                      />
                                    )}
                                  />
                                </div>
                              </Grid>
                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  <Grid container spacing={2}>
                                    <Grid item xs={5} md={5}>
                                      <label>CITY *</label>
                                    </Grid>
                                    <Grid item xs={7} md={7}>
                                      {errors.city && (
                                        <p className={styles.requiredContent}>
                                          {validationText.error.city}
                                        </p>
                                      )}
                                    </Grid>
                                  </Grid>
                                  <Controller
                                    control={control}
                                    name="city"
                                    render={({ field: { onChange, value } }) => (
                                      <CustomInputNoLabel
                                        placeholder=""
                                        type="text"
                                        value={value}
                                        onChange={onChange}
                                        disabled={submitLoading}
                                      />
                                    )}
                                  />
                                </div>
                              </Grid>

                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  <label>STATE</label>
                                  <FormControl sx={{ m: 1, minWidth: 120 }}>
                                    {loadingStateList && (
                                      <BackdropLoader open={true} />
                                    )}

                                    {stateForDrivingRange &&
                                    stateForDrivingRange !== undefined &&
                                    stateForDrivingRange?.length !== 0 ? (
                                      <Controller
                                        control={control}
                                        name="state"
                                        // {...register("country")}
                                        render={({
                                          field: { onChange, value },
                                        }) => (
                                          <Select
                                            id="demo-simple-select"
                                            onChange={onChange}
                                            value={value !== undefined && value}
                                          >
                                            {stateForDrivingRange &&
                                              stateForDrivingRange?.map((e) => {
                                                return (
                                                  <MenuItem
                                                    key={e?.id_state}
                                                    value={e?.id_state}
                                                  >
                                                    {e?.stateFull}
                                                  </MenuItem>
                                                );
                                              })}
                                          </Select>
                                        )}
                                      />
                                    ) : (
                                      <Select>
                                        <MenuItem disabled>
                                          - State not available -
                                        </MenuItem>
                                      </Select>
                                    )}
                                  </FormControl>
                                </div>
                              </Grid>
                              {/* ) } */}
                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  <Controller
                                    control={control}
                                    name="otherState"
                                    render={({ field: { onChange, value } }) => (
                                      <CustomInput
                                        label="OTHER STATE"
                                        placeholder=""
                                        type="text"
                                        value={value}
                                        onChange={onChange}
                                        disabled={submitLoading}
                                      />
                                    )}
                                  />
                                </div>
                              </Grid>
                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  <Controller
                                    control={control}
                                    name="zip"
                                    render={({ field: { onChange, value } }) => (
                                      <CustomInput
                                        label="ZIP CODE"
                                        placeholder=""
                                        type="text"
                                        value={value}
                                        onChange={onChange}
                                        disabled={submitLoading}
                                      />
                                    )}
                                  />
                                </div>
                              </Grid>
                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  <Grid container spacing={2}>
                                    <Grid item xs={5} md={5}>
                                      <label>COUNTRY *</label>
                                    </Grid>
                                    <Grid item xs={7} md={7}>
                                      {errors.country && (
                                        <p className={styles.requiredContent}>
                                          {validationText.error.country}
                                        </p>
                                      )}
                                    </Grid>
                                  </Grid>
                                  <FormControl sx={{ m: 1, minWidth: 120 }}>
                                    <Controller
                                      control={control}
                                      name="country"
                                      // {...register("country")}
                                      render={({ field: { onChange, value } }) => (
                                        <Select
                                          id="demo-simple-select"
                                          onChange={onChange}
                                          value={value !== undefined && value}
                                        >
                                          {countryData &&
                                            countryData?.map((e) => {
                                              return (
                                                <MenuItem
                                                  key={e?.id_country}
                                                  value={e?.id_country}
                                                  onClick={(event) =>
                                                    handleSelectMenu(event, e)
                                                  }
                                                >
                                                  {e?.countryFull}
                                                </MenuItem>
                                              );
                                            })}
                                        </Select>
                                      )}
                                    />
                                  </FormControl>
                                </div>
                              </Grid>
                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  <Controller
                                    control={control}
                                    name="phone"
                                    render={({ field: { onChange, value } }) => (
                                      <CustomInput
                                        label="PHONE NUMBER"
                                        placeholder=""
                                        type="number"
                                        value={value}
                                        onChange={onChange}
                                        onKeyPress={(e) => {
                                          if (
                                            e.key === "e" ||
                                            e.key === "E" ||
                                            e.key === "-"
                                          ) {
                                            e.preventDefault();
                                          }
                                        }}
                                        onPaste={(e) => {
                                          e.preventDefault();
                                          return false;
                                        }}
                                        disabled={submitLoading}
                                      />
                                    )}
                                  />
                                </div>
                              </Grid>
                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  <Controller
                                    control={control}
                                    name="website"
                                    render={({ field: { onChange, value } }) => (
                                      <CustomInput
                                        label="WEBSITE"
                                        placeholder=""
                                        type="text"
                                        value={value}
                                        onChange={onChange}
                                        disabled={submitLoading}
                                      />
                                    )}
                                  />
                                </div>
                              </Grid>
                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  <label>STATUS</label>
                                  <FormControl sx={{ m: 1, minWidth: 120 }}>
                                    <Controller
                                      control={control}
                                      name="status"
                                      render={({ field: { onChange, value } }) => (
                                        <Select
                                          defaultValue=""
                                          id="demo-simple-select"
                                          onChange={onChange}
                                          value={value ? value : ""}
                                        >
                                          {statusForEdit?.map((e) => {
                                            return (
                                              <MenuItem key={e?.id} value={e?.id}>
                                                {e?.value}
                                              </MenuItem>
                                            );
                                          })}
                                        </Select>
                                      )}
                                    />
                                  </FormControl>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                        </div>
                      )}
                    </div>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <div className={`${styles.range_sec_box} ${styles.range_form_cmn}`}>
                      <div className={styles.range_head}>
                        <p>Latitude and Longitude</p>
                      </div>
                      <div>
                        <div className={styles.formSec}>
                          <Grid container spacing={0}>
                            <Grid item sm={6} xs={12}>
                              <div className={styles.formGroup}>
                                <Grid container spacing={2}>
                                  <Grid item xs={5} md={5}>
                                    <label>Latitude </label>
                                  </Grid>
                                  <Grid item xs={7} md={7}>
                                    {errors.latitude && (
                                      <p className={styles.requiredContent}>
                                        {validationText.error.latitude}
                                      </p>
                                    )}
                                  </Grid>
                                </Grid>
                                <Controller
                                  control={control}
                                  name="latitude"
                                  render={({ field: { onChange, value } }) => (
                                    <CustomInputNoLabel
                                      placeholder=""
                                      type="number"
                                      value={value}
                                      onChange={onChange}
                                      disabled={submitLoading}
                                      onKeyPress={(e) => {
                                        if (e.key === "e" || e.key === "E") {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                  )}
                                />
                              </div>
                            </Grid>
                            <Grid item sm={6} xs={12}>
                              <div className={styles.formGroup}>
                                <Grid container spacing={2}>
                                  <Grid item xs={5} md={5}>
                                    <label>Longitude </label>
                                  </Grid>
                                  <Grid item xs={7} md={7}>
                                    {errors.longitude && (
                                      <p className={styles.requiredContent}>
                                        {validationText.error.longitude}
                                      </p>
                                    )}
                                  </Grid>
                                </Grid>
                                <Controller
                                  control={control}
                                  name="longitude"
                                  render={({ field: { onChange, value } }) => (
                                    <CustomInputNoLabel
                                      placeholder=""
                                      type="number"
                                      value={value}
                                      onChange={onChange}
                                      disabled={submitLoading}
                                      onKeyPress={(e) => {
                                        if (e.key === "e" || e.key === "E") {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                  )}
                                />
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      </div>
                    </div>
                    <div className={styles.Course_range_sec_box}>
                      <div className={styles.range_sec_inners}>
                        <div className={styles.range_head}>
                          <p>Edit Associated Courses</p>
                          <button
                            type="button"
                            onClick={() => setStatusopenBtn(!statusopenBtn)}
                          >
                            <img src={asset.search1} alt="img" />
                          </button>
                          {statusopenBtn ? (
                            <div className={styles.click_dropdown}>
                              <div className={styles.search_box_drop}>
                                <input
                                  type="text"
                                  placeholder="Search course"
                                  value={courses}
                                  onChange={handleRange}
                                />
                                <button
                                  className={styles.close}
                                  onClick={() => setStatusopenBtn(!statusopenBtn)}
                                >
                                  <CloseIcon />
                                </button>
                              </div>
                              <div className={styles.course_search_box_drop_cont}>
                                {loading && (
                                  <div style={{ color: "#146C94" }}>
                                    Loading Associated Courses...
                                  </div>
                                )}
                                {activeCourseList &&
                                activeCourseList?.length === 0 &&
                                loading !== true &&
                                !courseData?.course_details_data ? (
                                  <h5 className={styles.noDataAvailable}>
                                    {" "}
                                    No Course Found{" "}
                                  </h5>
                                ) : (
                                  <></>
                                )}
                                {error ? (
                                  <h5
                                    style={{
                                      marginTop: "3px",
                                      textAlign: "center",
                                      fontSize: "10px",
                                    }}
                                  >
                                    Enter at least 2 digit of course Name
                                  </h5>
                                ) : (
                                  <>
                                    {activeCourseList &&
                                    activeCourseList?.length !== 0 &&
                                    courses?.length !== 0 &&
                                    isNumericName === false ? (
                                      <ul>
                                        {activeCourseList?.map((e) => {
                                          return (
                                            <li
                                              className={styles.addSelecteCourse}
                                              onClick={
                                                !courseIdList.includes(
                                                  e?.id_courseInt
                                                )
                                                  ? (event) =>
                                                      addSelectCourseList(event, e)
                                                  : null
                                              }
                                            >
                                              <h2>{e?.courseName}</h2>
                                              <p>{e?.city}</p>
                                              {courseIdList.includes(
                                                e?.id_courseInt
                                              ) ? (
                                                <CheckCircleIcon />
                                              ) : null}
                                            </li>
                                          );
                                        })}
                                      </ul>
                                    ) : (
                                      <>
                                        {courseData?.course_details_data?.Status !==
                                          1 &&
                                        courses?.length !== 0 &&
                                        loading !== true ? (
                                          <h5 className={styles.noDataAvailable}>
                                            No related course found{" "}
                                          </h5>
                                        ) : (
                                          <ul>
                                            {loading !== true ? (
                                              <>
                                                {courseData?.course_details_data !==
                                                  null && isNumericName === true ? (
                                                  <li
                                                    onClick={
                                                      !courseIdList.includes(
                                                        courseData
                                                          ?.course_details_data
                                                          ?.id_courseInt
                                                      )
                                                        ? (event, e) =>
                                                            addSelectCourseDetails(
                                                              event,
                                                              e
                                                            )
                                                        : null
                                                    }
                                                  >
                                                    <h2>
                                                      {
                                                        courseData
                                                          ?.course_details_data
                                                          ?.courseName
                                                      }
                                                    </h2>

                                                    <p>
                                                      {
                                                        courseData
                                                          ?.course_details_data?.city
                                                      }
                                                    </p>
                                                    {courseIdList.includes(
                                                      courseData?.course_details_data
                                                        ?.id_courseInt
                                                    ) ? (
                                                      <CheckCircleIcon />
                                                    ) : null}
                                                  </li>
                                                ) : (
                                                  <></>
                                                )}
                                              </>
                                            ) : null}
                                          </ul>
                                        )}
                                      </>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          ) : null}
                        </div>
                        <div className={styles.course_range_table}>
                          <table className={styles.table_bar}>
                            {loadingCourses ? (
                              <p className={styles.noDataForCourse}>
                                Loading Associated Courses....
                              </p>
                            ) : (
                              <>
                                {coursesOfRangeDetails &&
                                coursesOfRangeDetails?.length !== 0 ? (
                                  <>
                                    <thead>
                                      <tr>
                                        <th className={styles.courseid}>COURSE ID</th>
                                        <th className={styles.coursename}>
                                          COURSE NAME
                                        </th>
                                        <th className={styles.address}>ADDRESS</th>
                                        <th className={styles.plus}></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                    {coursesOfRangeDetails?.map((e) => {
                                      return (
                                        
                                          <tr key="id">
                                            <td className={styles.courseid_cont}>
                                              {e?.id_courseInt}
                                              <div className={styles.tab_cont}>
                                                <p>{e?.courseName}</p>
                                                <p>{e?.city}</p>
                                              </div>
                                            </td>
                                            <td className={styles.coursename_cont}>
                                              {e?.courseName}
                                            </td>
                                            <td className={styles.address_cont}>
                                              {e?.address1} {e?.city}
                                            </td>
                                            <td>
                                              <div className={styles.remove_btn}>
                                                <div className={styles.plus_cont}>
                                                  <span
                                                    onClick={() => handleRemove(e)}
                                                  >
                                                    <img
                                                      src={asset.close}
                                                      alt="img"
                                                    />{" "}
                                                  </span>
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                      
                                      );
                                    })}
                                    </tbody>
                                  </>
                                ) : (
                                  <p className={styles.noDataForCourse}>
                                    No Associated Courses
                                  </p>
                                )}
                              </>
                            )}
                          </table>
                        </div>
                      </div>
                    </div>
                  </Grid>
                    <ModalWrapper
                      open={open}
                      onClose={handleClose}
                      handleClose={handleClose}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <NoificationModal
                        label="Warning"
                        backgroundColor={modalProperties.warning.backgroundColor}
                        image={modalProperties.warning.icon}
                        title="Range details are not saved"
                        content="Do you really want to exit?"
                        rejCallBack={redirectToPage}
                        affrCallBack={navigateToDrivingRange}
                      />
                    </ModalWrapper>
                </Grid>
              </form>
            </div>
          </div>
        </div>
      </Wrapper>
    </div>
  );
};

export default EditRangeInformation;
